import React, {
  useMemo, useRef, useState
} from 'react';
import {
  Title, ButtonMenu, Spacer
} from 'components/atoms';
import { Modal } from 'components/molecules';
import {
  MediaGallery,
  MediaUploadForm,
} from 'containers';
import styled from 'styled-components/macro';
import Carousel from 'react-slick';
import PropTypes from 'prop-types';
import { useForceUpdate, useRouterContext } from 'hooks'
import { useUserContext, isUserSubwebAdmin } from 'context/UserContext';


const MediaUploadGallery = ({
  isOpen,
  toggle,
  onSubmit,
  lang,
}) => {
  const formCarousel = useRef(null);
  const [activeForm, setActiveForm] = useState(0);
  const forceUpdate = useForceUpdate()

  const {
    match: {
      params: { subweb },
    },
  } = useRouterContext();

  const [{ user }] = useUserContext()
  const isAdmin = (user && user.admin) || isUserSubwebAdmin(user, subweb)
  const isEditor = (user && user.editor) || isUserSubwebAdmin(user, subweb)

  const goToForm = index => {
    setActiveForm(index);
    formCarousel?.current?.slickGoTo(index);
  };

  const isMediaUploadFormActive = useMemo(() => {
    const MediaUploadFormIndex = 1;
    return activeForm === MediaUploadFormIndex;
  }, [activeForm]);

  // update image values for currently editing language form
  const handleOnSubmitImage = imageValues => {
    onSubmit(imageValues)
    toggle()
  };

  const handleOnUploadImage = imageValues => {
    goToForm(0)
  };

  const handleMediaSelect = image => {
    const { id, url, data } = image;
    const [imageData] = data;
    const { alt, title } = imageData;

    handleOnSubmitImage({
      id,
      alt,
      title,
      url,
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} modifiers={['stretch']}>
      <Carousel
        ref={formCarousel}
        dots={false}
        infinite={false}
        slidesToShow={1}
        initialSlide={0}
        slidesToScroll={1}
        accessibility={false}
        draggable={false}
        swipe={false}
        arrows={false}
        adaptiveHeight
      >
        <CarouselSlide>
          <Top>
            <Title>Selecionar imagem</Title>
          </Top>
          <Spacer left="xl2" bottom="xl">
            <MediaGallery
              onSelect={handleMediaSelect}
              forceUpdate={forceUpdate}
              onClickUpload={() => goToForm(1)}
              isInput
              showPreview
              activeForm={activeForm}
            />
          </Spacer>
        </CarouselSlide>
        <CarouselSlide>
          {(isAdmin || isEditor) && (
            <Top hasSpacing>
              <ButtonMenu
                icon="arrow-back"
                modifiers={['clearSpacing', 'clean', 'primaryAlt', 'bold', 'big']}
                iconHeight={12}
                onClick={() => goToForm(0)}
              >
                Adicionar imagem
              </ButtonMenu>
            </Top>
          )
          }
          <Spacer left="xl2" bottom="xl">
            <MediaUploadForm
              onSubmit={handleOnUploadImage}
              isActive={isMediaUploadFormActive}
              language={lang}
              onDiscard={() => goToForm(0)}
            />
          </Spacer>
        </CarouselSlide>
      </Carousel>
    </Modal>
  );
};

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${props => props.theme.spacing.xl2};
  padding: ${props => `${props.theme.spacing.xl} ${props.theme.spacing.xl2} ${props.theme.spacing.xl2} ${props.theme.spacing.xl}`};
`;

const CarouselSlide = styled.div`
  padding: 0;
  &:focus {
    outline: 0;
  }
`;

MediaUploadGallery.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  lang: PropTypes.string,
};

MediaUploadGallery.defaultProps = {
  toggle: () => null,
  isOpen: false,
  onSubmit: () => null,
  lang: 'pt',
};

export default MediaUploadGallery;
